import { useEffect, useState } from 'react';
import { listResource } from '../../../api/cabsAdmin';

const useCabLookups = () => {
  const [vehicleCategories, setVehicleCategories] = useState([]);
  const [seatConfigs, setSeatConfigs] = useState([]);
  const [locations, setLocations] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [transportPackages, setTransportPackages] = useState([]);

  useEffect(() => {
    const params = { limit: 200 };
    listResource('vehicle-categories', params).then((res) => setVehicleCategories(res.data || res || [])).catch(() => {});
    listResource('seat-configurations', params).then((res) => setSeatConfigs(res.data || res || [])).catch(() => {});
    listResource('locations', params).then((res) => setLocations(res.data || res || [])).catch(() => {});
    listResource('routes', params).then((res) => setRoutes(res.data || res || [])).catch(() => {});
    listResource('transport-packages', params).then((res) => setTransportPackages(res.data || res || [])).catch(() => {});
  }, []);

  return {
    vehicleCategories,
    seatConfigs,
    locations,
    routes,
    transportPackages,
  };
};

export default useCabLookups;
